import React, { useCallback } from 'react';
import { FacilitiesFormProps } from './FormTypes';
import { observer } from 'mobx-react';
import { useMst } from '../../core/stores';
import { existingFacilityFormSchema } from './facility-form-schemas';
import { Form, getElementByName } from '@jht/react-library';
import { NewOrExistingFacility } from '../../models';

export const ExistingFacilityForm: React.FC<FacilitiesFormProps> = observer(
  ({ facility, isOpen, orderId, onChange }) => {
    const { digitalOrdersStore } = useMst();
    const facilityOptions = orderId
      ? digitalOrdersStore.facilitiesForSelectedOrganization(orderId)
      : [];
    const existingFacilityForm = existingFacilityFormSchema(
      facility.facilityId
        ? {
            id: facility.facilityId.toString(),
            name: digitalOrdersStore.getFacilityById(facility.facilityId.toString()).name,
          }
        : {
            name: '',
            id: null,
          },
      facilityOptions,
    );
    const handleSelectFacilityFormChange = useCallback(
      formState => {
        const selectedFacilityId = getElementByName(formState.elements, 'facility').value as string;
        onChange(
          { type: NewOrExistingFacility.EXISTING, facilityId: Number(selectedFacilityId) },
          formState.valid,
        );
      },
      [onChange],
    );

    return (
      <Form
        schema={existingFacilityForm}
        onChange={handleSelectFacilityFormChange}
        onSubmit={() => {}}
      >
        <></>
      </Form>
    );
  },
);
